import { createFileRoute } from '@tanstack/react-router';
import { ReportBuilderPage } from '@/features/analytics-reporting/ReportBuilderPage';

export const Route = createFileRoute('/_dashboard/dashboard/reporting/reports/$reportId_/edit')({
  component: EditAnalyticsReportPage,
});

function EditAnalyticsReportPage() {
  const { reportId } = Route.useParams();
  return <ReportBuilderPage reportId={reportId} />;
}
